import { useState, useEffect } from 'react';

const getViewportHeight = () =>
  typeof window === 'undefined'
    ? null
    : (window.visualViewport?.height ?? window.innerHeight);

export default function useStableViewportHeight() {
  const [height, setHeight] = useState(getViewportHeight);

  useEffect(() => {
    const measure = () => {
      const h = window.visualViewport?.height ?? window.innerHeight;
      setHeight(prev => (prev === null ? h : Math.min(prev, h)));
    };

    measure();
    window.visualViewport?.addEventListener('resize', measure);
    window.addEventListener('resize', measure);

    return () => {
      window.visualViewport?.removeEventListener('resize', measure);
      window.removeEventListener('resize', measure);
    };
  }, []);

  return height;
}